import { siteInfo } from '@/mocks/categories';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Fashion%20product%20flat%20lay%20photography%20with%20sneakers%20hoodie%20watch%20and%20sunglasses%20scattered%20on%20textured%20linen%20fabric%2C%20soft%20diffused%20daylight%20from%20above%2C%20sand%20and%20oatmeal%20neutral%20tones%2C%20editorial%20minimal%20aesthetic%20with%20generous%20negative%20space%2C%20high%20end%20product%20styling%20with%20organic%20composition&width=1800&height=1000&seq=hero-main-v4&orientation=landscape"
        alt="Hipobuy Spreadsheet product discovery database fashion flat lay"
        title="Hipobuy Spreadsheet - Product Finding Database"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>

      <div className="relative z-10 flex flex-col items-start justify-center h-full w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-xl">
          <div className="inline-block px-3 py-1 mb-5 border border-background-50/40 rounded-full">
            <span className="text-xs font-medium text-background-50/90 tracking-wide uppercase">SEO Shopping Resource</span>
          </div>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-medium text-background-50 leading-tight tracking-tight mb-4">
            {siteInfo.name}
          </h1>
          <p className="text-sm md:text-base text-background-50/80 leading-relaxed mb-6 max-w-md">
            {siteInfo.description}
          </p>
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
            <a
              href={siteInfo.mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="px-6 py-3 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-full transition-all cursor-pointer whitespace-nowrap flex items-center gap-2"
            >
              hipobuy sheet
              <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href="#categories"
              className="px-6 py-3 text-sm font-medium text-background-50 border border-background-50/40 hover:bg-background-50/10 rounded-full transition-all cursor-pointer whitespace-nowrap"
            >
              Browse Categories
            </a>
          </div>
          <div className="flex flex-wrap items-center gap-4 mt-8">
            {['Updated Guides', 'Spreadsheet Comparisons', 'Safety Tips', 'Global Resource'].map((badge) => (
              <span key={badge} className="flex items-center gap-1.5 text-xs text-background-50/70">
                <i className="ri-check-line text-primary-400"></i>
                {badge}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}